
import { safeAddEventListener } from './dom-helpers';

/**
 * Initialize all global scripts that might be running across the application
 * This helps ensure scripts only execute when their target elements exist
 */
export function initializeGlobalScripts() {
  // Handle any share modal functionality
  safeAddEventListener('.share-button', 'click', (e) => {
    const shareModal = document.querySelector('.share-modal');
    if (shareModal) {
      e.preventDefault();
      shareModal.classList.toggle('active');
    }
  });

  // Any other global scripts that might cause similar errors can be added here
}
